/* Library */
import React, { Component } from 'react';
import { Link } from 'react-router';
import { browserHistory } from 'react-router';
import { connect } from 'react-redux';
import { asyncConnect } from 'redux-connect';

import InputButton from '../../../../components/ZUILib/InputButton';
import SelectionTab from '../../../../components/ZUILib/SelectionTab';
import Image from '../../../../components/ZUILib/Image';
import Warning from '../../../../components/Warning';
import ApplyCSS from '../../../../components/ApplyCSS';
import AppEvents from '../../../App/AppEvents';
import { eventCategory } from '../../../../utils/clientConstant';

import * as createEventObject from '../../../createEvent/actions';
import * as typeActions from './actions';
import * as labelsActions from '../../../../components/labels/actions';
import * as EventCategoryActions from '../../../../components/eventcategory/actions';

import commonUtil from '../../../../utils/commonUtil';
import { createTag } from '../../../../utils/googleTagManagerUtils';

const channel = commonUtil.getChannel();
const { isLablesLoaded, loadLables } = labelsActions;
const { loadCategorySpecificEvents } = createEventObject;
const { CheckEventCreateValid } = typeActions;
const { isEventCategoryLoaded, loadEventCategoryEvent } = EventCategoryActions;
const pageName = 'SelectTypeCelebration';
const applicationRoutes = commonUtil.getApplicationRoutes();
const { strategy } = require('../../createEventStrategy/strategy');

@asyncConnect([
  {
    promise: ({ store: { dispatch, getState } }) => {
      if (!isLablesLoaded(getState())) {
        return dispatch(loadLables());
      }
      return undefined;
    },
  },
  {
    promise: ({ store: { dispatch, getState } }) => {
      const state = getState();
      const categoryType = state.createEventObject.SelectMesaType;
      const profileId =
        state.user && state.user.data.result && state.user.data.result.profileId ? state.user.data.result.profileId : '';

      return dispatch(loadCategorySpecificEvents(categoryType, profileId));
    },
  },
  {
    promise: ({ store: { dispatch, getState } }) => {
      if (!isEventCategoryLoaded(getState())) {
        return dispatch(loadEventCategoryEvent());
      }
      return undefined;
    },
  },
])
@connect(
  store => ({
    lables: store.labels.data,
    error: store.labels.error,
    loading: store.labels.loading,
    extraData: store.labels.extraData,
    createEventObject: store.createEventObject,
    user: store.user.data,
    eventCategoryType: store.eventcategory.data,
  }),
  { ...labelsActions, ...typeActions, ...createEventObject, ...EventCategoryActions },
)

class SelectTypeCelebration extends Component {
  constructor(props) {
    super(props);
    this.categoryType = this.props.createEventObject.SelectMesaType;
    this.categorySpecificEvents = null;
    this.warningMessage = null;
  }

  componentWillMount() {
    if (this.props.createEventObject.SelectMesaType === undefined && browserHistory) {
      browserHistory.push(applicationRoutes.mesaType);
    }
  }

  componentWillUnmount() {
    AppEvents.unsubscribe(this.wapBackButtonEvent);
  }

  componentDidMount() {
    const { location = {} } = this.props || {};
    const { state } = location;

    if (state) this.warning.setMessage(this.props.location.state.error);

    this.wapBackButtonEvent = AppEvents.subscribe(AppEvents.EVENT_REGISTER.WAP_BACK_BUTTON_CLICKED);

    if (this.wapBackButtonEvent) {
      AppEvents.publish(this.wapBackButtonEvent, [this.handleBackClickSelectTypeCelebration]);
    }
  }

  handleClickSelectTypeCelebration = () => {
    const { clearEventData, defineCreateEventData = () => {}, user = {} } = this.props;
    const { result = {} } = user || {};
    const { profileId = 0 } = result || {};

    clearEventData();

    const selectEventType = document.querySelector('.cSelect select').value;
    const selectEventTypeObj = document.querySelector('#selectTypeCelebration');

    let selectEventTypeText = selectEventTypeObj.options[selectEventTypeObj.selectedIndex].value;

    this.categorySpecificEvents.forEach((item) => {
      if (selectEventTypeText === item.nameInEnglish || selectEventTypeText === item.name) {
        selectEventTypeText = item.name;
      }
    });

    if (
      selectEventType === commonUtil.getLabel(this.props.lables.createEventStep1, 'createEventStep1..selecttitle1.label')
    ) {
      this.warning.setMessage('Seleccione un evento para continuar');
      return null;
    }

    let selectedEventConfiguration = '';
    selectedEventConfiguration = strategy.strategies[selectEventType];

    defineCreateEventData(pageName, { selectEventType, selectedEventConfiguration });

    if (profileId) {
      CheckEventCreateValid(selectEventTypeText, profileId)
        .then((response) => {
          if (response.body.status.status === 'success') {
            createTag({
              event: 'mesa_regalos',
              phase: 'Crear mesa de regalos',
              step: 'Selecciona el tipo de celebracion',
              selection: `${this.categoryType}|${selectedEventConfiguration.name}`,
              seccion: 'Mesa de Regalos',
            });
            this.handleNavigateonSuccess(selectedEventConfiguration);
          } else if (response.body.status.status === 'failure' || response.status === 'failure') {
            if (response.body.status.errorMessage) {
              this.warning.setMessage(response.body.status.errorMessage);
            } else {
              this.warning.setMessage(response.errorMessage);
            }
          }
        })
        .catch((error) => {
          this.warning.setMessage(error.body);
        });
    } else {
      this.handleNavigateonSuccess(selectedEventConfiguration);
    }
    return null;
  };

  handleBackClickSelectTypeCelebration = () => {
    createTag({
      event: 'mesa_regalos',
      seccion: 'Mesa de Regalos',
      phase: 'Crear mesa de regalos',
      step: 'Atras tipo de celebracion',
    });
    browserHistory.push(applicationRoutes.mesaType);
  };

  handleNavigateonSuccess = (selectedEventConfiguration) => {
    browserHistory.push({ pathname: selectedEventConfiguration.url, state: selectedEventConfiguration });
  };

  handleOptions = (selectedOption) => {
    this.warning.setMessage('');
    this.ctl.style.display = 'none';
    this.ctl.innerText = '';
    this.categorySpecificEvents.forEach((item) => {
      if (item.name === selectedOption.text && item.disclaimerMsg) {
        this.ctl.style.display = 'block';
        this.ctl.innerText = item.disclaimerMsg;
      }
    });
  };

  render() {
    const { lables, createEventObject: createEventObjectProp } = this.props;
    this.categorySpecificEvents =
      createEventObjectProp.data && createEventObjectProp.data.result && createEventObjectProp.data.result.eventTypesInfo;

    const _celebratedImagesrc = [
      {
        media: '(max-width: 465px)',
        srcSet: commonUtil.getAssetURL() + '/images/celebrationActive.png',
      },
    ];

    const celebratedImageAttr = {
      id: 'img1',
      src: commonUtil.getAssetURL() + '/images/celebrationActive.png',
      alt: 'Liverpool',
      width: 'auto',
      height: 'auto',
    };

    const _openEventImagesrc = [
      {
        media: '(max-width: 465px)',
        srcSet: commonUtil.getAssetURL() + '/images/eventsActive.png',
      },
    ];

    const openEventImageAttr = {
      id: 'img1',
      src: commonUtil.getAssetURL() + '/images/eventsActive.png',
      alt: 'Liverpool',
      width: 'auto',
      height: 'auto',
    };

    const backButtonAttr = {
      value: 'Regresar',
      style: 'btnSecondaryAction size-Large',
      onClickHandler: this.handleBackClickSelectTypeCelebration,
      iconClass: 'iconLeft icon-flecha_light_izq',
    };

    const nextButtonAttr = {
      value: ' Siguiente paso',
      style: 'btnPrimary size-Large',
      onClickHandler: this.handleClickSelectTypeCelebration,
      iconClass: 'iconRight icon-flecha_lightsvg_derecha',
    };

    const wapNextButtonAttr = {
      value: 'Siguiente paso',
      style: 'btnPrimary size-Full',
      onClickHandler: this.handleClickSelectTypeCelebration,
      iconClass: 'iconRight icon-flecha_lightsvg_derecha',
    };

    const celebrationTypes = [];

    if (this.categorySpecificEvents) {
      this.categorySpecificEvents.map((celebrationEvent) => {
        const _celebrationType = {};
        _celebrationType.id = celebrationEvent.nameInEnglish;
        _celebrationType.value = celebrationEvent.nameInEnglish;
        _celebrationType.disabled = !celebrationEvent.enabled;
        _celebrationType.text = celebrationEvent.name;
        return celebrationTypes.push(_celebrationType);
      });
    } else {
      celebrationTypes.push(commonUtil.getLabel(lables.createEventStep1, 'createEventStep1..selecttitle1.label'));
    }

    if (channel === 'wap') {
      return (
        <React.Fragment>
          <ApplyCSS pageName={pageName} />
          <div className={'selectTypeCelebration createEventAnimationRight'}>
            <div className={'row'} style={{ background: '#f7f3f0' }}>
              <div className={'col-xs-12'}>
                <div className="innerWrap" style={{ textAlign: 'center' }}>
                  <div className="text-center">
                    <Warning type="error" text={this.warningMessage} ref={warning => (this.warning = warning)} />
                  </div>
                  <h2 style={{ fontSize: '18px', color: '#3b3b3e' }}>
                    {commonUtil.getLabel(lables.celebrationPage, 'celebrationPage.celebrationselect.title')}
                  </h2>
                  <div className="logoContent">
                    {this.categoryType === eventCategory.CELEBRATION ? (
                      <Image imageAttr={celebratedImageAttr} _imgsrc={_celebratedImagesrc} />
                    ) : (
                      <Image imageAttr={openEventImageAttr} _imgsrc={_openEventImagesrc} />
                    )}
                  </div>
                  {this.categoryType === eventCategory.CELEBRATION ? (
                    <h3 style={{ fontSize: '16px', color: '#3b3b3e', marginTop: '10px' }}>
                      {commonUtil.getLabel(lables.categoryLanding, 'categoryLanding.celebration.name')}
                    </h3>
                  ) : (
                    <h3>{commonUtil.getLabel(lables.categoryLanding, 'categoryLanding.open.name')}</h3>
                  )}
                  <div className="innerOptions">
                    <SelectionTab
                      id="selectTypeCelebration"
                      classname={'cSelect required'}
                      options={celebrationTypes}
                      optionCaption={commonUtil.getLabel(
                        lables.createEventStep1,
                        'createEventStep1..selecttitle1.label',
                      )}
                      optionText={'text'}
                      optionValue={'value'}
                      disable={celebrationTypes.length < 0}
                      handleSelectedOption={this.handleOptions}
                      ref={ref => (this.selectedCelebrationType = ref)}
                    />
                  </div>
                  <div
                    className="col-sm-12 col-md-12 confirmAgeMessage"
                    style={{ display: 'none' }}
                    ref={dv => (this.ctl = dv)}
                  >
                    <p />
                  </div>
                  <div className="innerButtons">
                    <Link to="" title="Siguiente paso">
                      <InputButton buttonAttr={wapNextButtonAttr}>Siguiente paso</InputButton>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </React.Fragment>
      );
    }

    return (
      <React.Fragment>
        <ApplyCSS pageName={pageName} />
        <div className={'container selectTypeCelebration createEventAnimationRight'} style={{ background: '#f7f3f0' }}>
          <div className={'row innerMain'}>
            <div className={'col-sm-12 col-md-12'}>
              <div className="innerWrap">
                <div className="text-center">
                  <div className="col-md-12 col-md-6 col-md-offset-3">
                    <div className={'typeEventWarning-container'}>
                      <Warning type="error" text={this.warningMessage} ref={warning => (this.warning = warning)} />
                    </div>
                    <h2>{commonUtil.getLabel(lables.celebrationPage, 'celebrationPage.celebrationselect.title')}</h2>
                    <div className="logoContent">
                      {this.categoryType === eventCategory.CELEBRATION ? (
                        <Image imageAttr={celebratedImageAttr} _imgsrc={_celebratedImagesrc} />
                      ) : (
                        <Image imageAttr={openEventImageAttr} _imgsrc={_openEventImagesrc} />
                      )}
                    </div>
                    {this.categoryType === eventCategory.CELEBRATION ? (
                      <h3>{commonUtil.getLabel(lables.categoryLanding, 'categoryLanding.celebration.name')}</h3>
                    ) : (
                      <h3>{commonUtil.getLabel(lables.categoryLanding, 'categoryLanding.open.name')}</h3>
                    )}
                    <div className="innerOptions">
                      <SelectionTab
                        id="selectTypeCelebration"
                        classname={'cSelect required selectOptions'}
                        options={celebrationTypes}
                        optionCaption={commonUtil.getLabel(
                          lables.createEventStep1,
                          'createEventStep1..selecttitle1.label',
                        )}
                        optionText={'text'}
                        optionValue={'value'}
                        disable={celebrationTypes.length < 0}
                        handleSelectedOption={this.handleOptions}
                        ref={ref => (this.selectedCelebrationType = ref)}
                      />
                    </div>
                  </div>
                  <div
                    className="col-sm-12 col-md-12 confirmAgeMessage"
                    style={{ display: 'none' }}
                    ref={dv => (this.ctl = dv)}
                  >
                    <p />
                  </div>
                  <div className="col-xs-12 col-sm-6 col-md-4 col-md-offset-1">
                    <InputButton buttonAttr={backButtonAttr}> Regresar </InputButton>
                  </div>
                  <div className="col-xs-12 col-sm-6 col-md-4 col-md-offset-2">
                    <Link to="" title="Siguiente paso">
                      <InputButton buttonAttr={nextButtonAttr}>Siguiente paso</InputButton>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default SelectTypeCelebration;
